import { FaArrowLeft } from "react-icons/fa"
import KitCard from "../../components/KitCard"
import { useOrcamentoContext } from "../../contexts/orcamentoContext"
import { GridContainer } from "../../global"
import { BackButton, ContentKits, HeroTitle } from "./style"
import { useNavigate } from "react-router-dom"

function Orcamento(){
    const { kitOrcamento } = useOrcamentoContext()
    const navigate = useNavigate();
    const kits = kitOrcamento?.result?.kit

    const kitsParaExibir = kits ? kits.slice(0, 4) : [];


    const handleGoBack = () => {
        navigate(-1);
    };

    return(
        <>
            <HeroTitle>
                <GridContainer>
                    <BackButton onClick={handleGoBack}><FaArrowLeft /> Voltar</BackButton>
                    <h1>Orçamento diponibilizado</h1>
                    <h4>Confira abaixo as ofertas disponibilizadas para o seu kit</h4>
                </GridContainer>
            </HeroTitle>
             <GridContainer>
               
                {kits ? (
                    <>
                       
                        <h2 style={{ margin: "0", textAlign: "center", marginTop: "20px" }}>{`${kitsParaExibir.length} kits encontrados`}</h2>
                        <ContentKits>
                          
                            {kitsParaExibir.map((kit, index) => (
                                <KitCard key={index} kit={kit} />
                            ))}
                        </ContentKits>
                    </>
                ) : (
                    <ContentKits>
                        <h2>Não foram econtrados kits</h2>
                    </ContentKits>
                )}
            </GridContainer>
        </>
    )
}

export default Orcamento